// extracted by css-extract-rspack-plugin
export default {"besidePane":"l7q_rg_tXlQW_0Ur"};